export const vendorItem = {
  properties: {
    fonts: {
      status: {
        textColor: 'text-color-primary',
        typography: 'font-body-highcontrast-sentence-small',
      },
      headline: {
        textColor: 'text-color-primary',
        typography: 'font-subtitle-highcontrast-sentence-large',
      },
      categories: {
        textColor: 'text-color-primary',
        typography: 'font-body-midcontrast-sentence-small',
      },
      conditions: {
        textColor: 'text-color-feedback-warning',
        typography: 'font-body-midcontrast-sentence-small',
      },
      cpc: {
        textColor: 'text-color-tertiary',
        typography: 'font-label-midcontrast-small',
      },
      etaDefault: {
        textColor: 'text-color-secondary',
        typography: 'font-body-midcontrast-sentence-medium',
      },
      etaQuick: {
        textColor: 'text-color-feedback-positive',
        typography: 'font-subtitle-highcontrast-sentence-medium',
      },
      etaDelay: {
        textColor: 'text-color-feedback-error',
        typography: 'font-subtitle-highcontrast-sentence-medium',
      },
      feeDefault: {
        textColor: 'text-color-secondary',
        typography: 'font-body-midcontrast-sentence-medium',
      },
      feeFree: {
        textColor: 'text-color-primary',
        typography: 'font-subtitle-highcontrast-sentence-medium',
      },
      feeVariable: {
        textColor: 'text-color-secondary',
        typography: 'font-body-midcontrast-sentence-medium',
      },
      feePlusFree: {
        textColor: 'text-color-primary',
        typography: 'font-subtitle-highcontrast-sentence-medium',
      },
      feePlusDiscount: {
        textColor: 'text-color-primary',
        typography: 'font-body-midcontrast-sentence-medium',
      },
      originalFee: {
        textColor: 'text-color-tertiary',
        typography: 'font-body-midcontrast-strikethrough-small',
      },
      vendorStatusMedium: {
        textColor: 'text-color-feedback-informative',
        typography: 'font-subtitle-highcontrast-sentence-medium',
      },
      vendorStatusLarge: {
        textColor: 'text-color-inverted',
        typography: 'font-subtitle-highcontrast-sentence-large',
      },
    },
  },
  categories: {
    default: {
      shared: {
        cardPadding: 'spacing-component-xlarge',
        headerPadding: 'spacing-component-large',
        headerTopBorderRadius: 'border-radius-default',
        headerBottomRowLeftColumnGap: 'spacing-component-small',
        headerMarginBottom: 'spacing-component-medium',
        bodyRightMarginLeft: 'spacing-component-medium',
        statusLargeRowGap: 'spacing-component-medium',
        statusTopBorderRadius: 'border-radius-default',
        statusSurfaceColorDefault: 'shape-color-surface-quaternary',
        statusSurfaceColorLoud: 'shape-color-surface-communication-accent',
      },
      states: {
        idle: {
          cardSurfaceColor: 'shape-color-surface-action-default-enabled',
        },
        hover: {
          cardSurfaceColor: 'shape-color-surface-action-default-hover',
        },
        pressed: {
          cardSurfaceColor: 'shape-color-surface-action-default-pressed',
        },
        focused: {
          cardSurfaceColor: 'shape-color-surface-action-default-focused',
        },
      },
    },
  },
};
